<template>
  <div>
    <p class="font-weight-bold mb-0" :class="numAnswersToGive <= numAnswersGiven ? 'text-dark-green' : 'text-orange'">
      This Location has specific questions you must be aware about, {{ numAnswersToGive }} must be answered, you have answered {{ numAnswersGiven }}.
    </p>

    <div v-if="givenResponses.length" class="rounded bg-gray-300 p-2">
      <template v-for="(question, questionKey) in locationQuestions">
        <question-response
          :question="question"
          :cart="cart"
          :sale="sale"
          v-model="givenResponses[questionKey]"
          ></question-response>
      </template>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    questionResponses: {
      type: Array,
    },
    locationQuestions: {
      type: Array,
    },
    cart: {
      type: Object,
    },
    sale: {
      type: Object,
    },
  },

  data() {
    return {
      givenResponses: [],
    };
  },

  model: {
    event: 'change',
    prop: 'questionResponses'
  },

  watch: {
    givenResponses: {
      deep: true,
      handler(newValue, oldValue) {
        // console.log('givenResponses in LQRC changed', newValue);

        this.$emit('change', JSON.parse(JSON.stringify(newValue.filter(gr => gr.id))));
      },
    },
  },

  computed: {
    numAnswersToGive() {
      return this.locationQuestions.filter(rq => rq.required == 1).length
    },

    numAnswersGiven() {
      return this.givenResponses.filter(gr => {
        if (this.locationQuestions.filter(lq => lq.id == gr.questionable_id)[0].type == 'CHECKBOX') {
          if (gr.response == 0 || gr.response === null) {
            return false;
          } else {
            return true;
          }
        } else if (this.locationQuestions.filter(lq => lq.id == gr.questionable_id)[0].type == 'RADIO' && gr.response === null) {
          return false;
        } else if (gr.response == '' || gr.response == null) {
          return false;
        }

        return true;
      }).length;
    },

    locationQuestionIdsRequired() {
      return this.locationQuestions.filter(rq => rq.required == 1).map(rq => rq.id);
    },

    locationQuestionResponseErrors() {
      if (this.locationQuestionResponseError.length) {
        if (Object.values(this.locationQuestionResponseError).includes(true)) {
          flash(this.locationQuestionResponseErrors, 'danger');
          return 'There are Location Question(s) to answer';
        }
      }

      return null;
    },

    locationQuestionResponseError() {
      var locationQuestionResponseError = {}

      if (this.locationQuestionIdsRequired && this.locationQuestionIdsRequired.length && this.givenResponses && this.givenResponses.length) {
        this.locationQuestionIdsRequired.forEach(lqid => {
          var iteratedId = this.locationQuestions.findIndex(lq => lq.id == lqid);
          if (this.locationQuestions[iteratedId].required == 1) {
            locationQuestionResponseError[iteratedId] = false;

            if (this.locationQuestions[iteratedId].type == 'CHECKBOX') {
              if (this.givenResponses[iteratedId].response == 0 || this.givenResponses[iteratedId].response === null) {
                locationQuestionResponseError[iteratedId] = true;
              }
            } else if (this.locationQuestions[iteratedId].type == 'RADIO' && this.givenResponses[iteratedId].response === null) {
              locationQuestionResponseError[iteratedId] = true;
            } else if (this.givenResponses[iteratedId].response == '' || this.givenResponses[iteratedId].response == null) {
              locationQuestionResponseError[iteratedId] = true;
            }
          }
        });
      }

      return locationQuestionResponseError;
    },
  },

  methods: {
    validation() {

    },

    createResponse(questionResponse) {
      // console.log('createResponse', questionResponse, questionResponse.questionable_id);
    }, // createResponse()

    updateResponse(questionResponse) {
      // console.log('updateResponse', questionResponse, questionResponse.questionable_id);
    }, // updateResponse()

  },

  mounted() {
    this.locationQuestions.forEach(rq => {
      let qr = this.questionResponses.find(qr => qr.questionable_id == rq.id);

      if (qr) {
        qr = JSON.parse(JSON.stringify(qr));
        qr.response_id = qr.id;
        this.givenResponses.push(qr);
      } else {
        if (this.cart) {
          this.givenResponses.push({
            response_id: -1,
            cart_id: this.cart.id,
            questionable_type: 'App\\Models\\Location\\LocationQuestion',
            questionable_id: rq.id,
            response: null
          });
        } else {
          this.givenResponses.push({
            response_id: -1,
            sale_id: this.sale.id,
            questionable_type: 'App\\Models\\Location\\LocationQuestion',
            questionable_id: rq.id,
            response: null
          });
        }
      }
    });
  }
}
</script>
